import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { LogIn, ShieldAlert } from "lucide-react";
import solveLogoIcon from "@/assets/solve-logo-icon.png";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <main className="min-h-screen flex items-center justify-center p-4 bg-background">
        <div className="w-full max-w-sm text-center space-y-6">
          <div className="flex justify-center">
            <img
              src={solveLogoIcon}
              alt="Solve iAgro"
              className="h-16 w-16 rounded-xl shadow-lg"
            />
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-center gap-2 text-amber-500">
              <ShieldAlert className="h-5 w-5" />
              <h1 className="text-xl font-semibold text-foreground">Sessão expirada</h1>
            </div>
            <p className="text-sm text-muted-foreground">
              Para sua segurança, você foi desconectado automaticamente. Faça login novamente para continuar.
            </p>
          </div>

          <Button
            onClick={() => navigate("/auth")}
            className="w-full gap-2"
            size="lg"
          >
            <LogIn className="h-4 w-4" />
            Fazer Login Novamente
          </Button>
        </div>
      </main>
    );
  }

  return <>{children}</>;
}
